import { FreeSpinOverlayEvent, SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
import { GlowFilter } from "pixi-filters";
import { Container, Point } from "pixi.js";
import { GameTestEvent } from "../../../controller/event/GameEvent";
import { GameMathUtil } from "../../../utils/GameMathUtil";
import { TitanSpineTrailModifier } from "../../../utils/SpineTrailModifier";
/**
 * GameFreeSpinsOverlay.ts
 */
export class GameFreeSpinsOverlay extends AbstractGameView {
    constructor(factory, landscapeProperties, portraitProperties) {
        super(factory, landscapeProperties, portraitProperties);
        this.landscapeProperties = landscapeProperties;
        this.portraitProperties = portraitProperties;
        this.collectionSpine = [];
        this.collectionModifier = [];
        Logger.addObjectRef(this);
        const holder = this.addChild(new Container());
        for (let i = 0; i < 5; i++) {
            const spine = TitanSpine.createSpine(holder, "collection-trail", this.landscapeProperties.collectionSpineProperties, this.portraitProperties?.collectionSpineProperties);
            const modifier = new TitanSpineTrailModifier(spine);
            this.collectionSpine.push(spine);
            this.collectionModifier.push(modifier);
            SpineUtil.addNamedEventListener(spine, "impact", this.handleCollectionImpact, this, 0);
            spine.filters ?? (spine.filters = []);
            spine.filters.push(new GlowFilter({
                distance: this.uiProperties.dabTrailGlowDistance,
                outerStrength: this.uiProperties.dabTrailGlowStrength,
                color: this.uiProperties.dabTrailColours[i],
            }));
        }
        this.registerGame(SlingoEvent.REELS_AWARD, this.reset);
        this.registerGame(CommonGameEvent.RECOVERY, this.reset);
        this.registerGame(SlingoEvent.FREE_SPIN_AWARD, this.handleFreeSpinAward);
        this.registerGame(FreeSpinOverlayEvent.FREE_SPIN_START, this.handleFreeSpinStart);
        this.registerGame(GameTestEvent.FREE_SPIN_OVERLAY, this.handleTestEvent);
    }
    handleTestEvent(event) {
        this.reset();
        this.playTrail(event.getCurrentTarget() ?? 0);
    }
    handleCollectionImpact() {
        this.dispatchGame(FreeSpinOverlayEvent.FREE_SPIN_END);
    }
    reset() {
        this.collectionIndex = 0;
    }
    handleFreeSpinAward() {
        this.dispatchGame(FreeSpinOverlayEvent.FREE_SPIN_START);
    }
    handleFreeSpinStart() {
        // Get the free spin index in the reels for the current collection.
        const freeSpinIndexes = this.model.getSpinResult().getReelSequence().getFreeSpinIndexes();
        const freeSpinIndex = freeSpinIndexes[this.collectionIndex];
        this.playTrail(freeSpinIndex);
        // Increment in preparation for the next collection.
        ++this.collectionIndex;
    }
    getTargetPositions(reelIndex) {
        return this.uiProperties.targetPositions[reelIndex].map(target => GameMathUtil.randomPointInCircle(this.uiProperties.maxRandomness, target));
    }
    playTrail(reelIndex) {
        const start = this.getTrailStartPosition(reelIndex);
        const end = this.getTrailEndPosition(reelIndex);
        SpineUtil.play(this.collectionSpine[reelIndex], "trail");
        this.collectionModifier[reelIndex].alignToPath([start, ...this.getTargetPositions(reelIndex), GameMathUtil.add(end, this.uiProperties.endTrailBodgeOffset[reelIndex])], 2);
    }
    getTrailStartPosition(reelIndex) {
        const location = this.locationManager.getLocation(`${SlingoStyle.REEL}_${reelIndex}`);
        const globalPosition = location.position;
        const localPosition = this.toLocal(globalPosition);
        return new Point(localPosition.x - this.collectionSpine[reelIndex].x, localPosition.y - this.collectionSpine[reelIndex].y);
    }
    getTrailEndPosition(reelIndex) {
        const globalPosition = this.locationManager.getLocation("FreeSpinCounter").position;
        const localPosition = this.toLocal(globalPosition);
        return new Point(localPosition.x - this.collectionSpine[reelIndex].x, localPosition.y - this.collectionSpine[reelIndex].y);
    }
}
//# sourceMappingURL=GameFreeSpinsOverlay.js.map